import ChevronLeft from 'Icons/ChevronLeft';
import {
  BackButton,
  GiftsHeader,
  GiftsWrapper,
  RedeemAction,
  RedeemActionText,
  RedeemContent,
  RedeemContentInfo,
  RedeemInfoText,
  RedeemInfoTitle,
  RedeemWarning,
  Warning,
} from './Redeem.styles';
import { useNavigate, useParams } from 'react-router-dom';
import CouponCard from 'components/CouponCard';
import Button from 'components/Button';
import { theme } from 'twin.macro';
import Label from 'components/Typography/Label';
import WarningIcon from 'assets/icons/warning.png';
import { useEffect, useState } from 'react';
import useRedeem from 'store/useRedeem';
import { useTranslation } from 'react-i18next';
import { getMobileOS } from 'helpers/GlobalHelper';
import { Loading } from 'components/LottieFiles';
import useUser from 'store/useUser';

const RedeemPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const { coupons, products } = useRedeem();
  const { isLogged } = useUser();

  const goBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (!isLogged) navigate('/start');
    const id = params.id;
    const coupon = coupons.find((coupon) => coupon.product === id);
    // get product info
    const product = products.find((product) => product._id === id);
    setData({ ...coupon, ...product });
    if (coupon && coupon.couponCode) setLoading(false);
    // eslint-disable-next-line
  }, [params]);

  const handleRedirectMap = () => {
    const loc = data.trader.loc;
    // Open map with latitude and longitude
    if (getMobileOS() === 'iOS') {
      window.location.href = `maps://maps.google.com/maps?q=${loc[1]},${loc[0]}`;
    } else {
      window.open(
        `https://www.google.com/maps/search/?api=1&query=${loc[1]},${loc[0]}`,
      );
    }
  };

  return (
    <GiftsWrapper>
      <GiftsHeader>
        <BackButton onClick={goBack}>
          <ChevronLeft width="17" height="23" />
        </BackButton>
      </GiftsHeader>
      <RedeemContent>
        {!loading ? (
          <>
            <CouponCard couponCode={data.couponCode} />
            <RedeemContentInfo>
              {t('youWon')}
              <RedeemInfoText>
                {data?.reduction ? `-${data.reduction}%` : t('free')}
              </RedeemInfoText>
              <RedeemInfoTitle>{data?.name}</RedeemInfoTitle>
            </RedeemContentInfo>
            <RedeemAction>
              <RedeemActionText>
                <Label>{t('claimgift')}</Label>
                {/* <RedeemLocation>8647 Cassin Trafficway</RedeemLocation> */}
              </RedeemActionText>
              <Button
                width="90%"
                hasAfter
                borderColor={theme`colors.darkGray`}
                afterBg="black"
                onClick={handleRedirectMap}
              >
                {t('openMap')}
              </Button>
              <RedeemWarning>
                <Warning src={WarningIcon} alt="warning" className="w-5 h-5" />
                {t('warningCoupon')}
              </RedeemWarning>
            </RedeemAction>
          </>
        ) : (
          <Loading />
        )}
      </RedeemContent>
    </GiftsWrapper>
  );
};

export default RedeemPage;
